import request from '@/utils/request'

let IssueOrderApi = {
  // 对单列表（后台）
  index(data, errorback) {
    return request._get('/shop/issueorder.issueorder/index', data, errorback);
  },

  // 对单详情
  detail(data, errorback) {
    return request._get('/shop/issueorder.issueorder/detail', data, errorback);
  },
  // 单笔对单接洽商家列表
  contactMerchants(data, errorback) {
    return request._get('/shop/issueorder.issueorder/contactMerchants', data, errorback);
  },

  // 删除对单（软删）
  delete(data, errorback) {
    return request._post('/shop/issueorder.issueorder/delete', data, errorback);
  },

  // 恢复已软删对单
  restore(data, errorback) {
    return request._post('/shop/issueorder.issueorder/restore', data, errorback);
  },

  // 修改状态
  status(data, errorback) {
    return request._post('/shop/issueorder.issueorder/status', data, errorback);
  },

  // 编辑对单（统一入口，根据业务类型在后端分发）
  edit(data, errorback) {
    return request._post('/shop/issueorder.issueorder/edit', data, errorback);
  },

  // 列表热门推荐（action: set | clear）
  hotRecommend(data, errorback) {
    return request._post('/shop/issueorder.issueorder/hotRecommend', data, errorback);
  },

  // ---------- 今日大单推荐 ----------
  topIndex(data, errorback) {
    return request._post('/shop/issueorder.top/index', data, errorback);
  },
  topAdd(data, errorback) {
    return request._post('/shop/issueorder.top/add', data, errorback);
  },
  topEdit(data, errorback) {
    return request._get('/shop/issueorder.top/edit', data, errorback);
  },
  topEditSubmit(data, errorback) {
    return request._post('/shop/issueorder.top/edit', data, errorback);
  },
  topDelete(data, errorback) {
    return request._post('/shop/issueorder.top/delete', data, errorback);
  },
  topChangeStatus(data, errorback) {
    return request._post('/shop/issueorder.top/changeStatus', data, errorback);
  },
  // 从对单列表“推荐”入口添加（传入 issue_order_id、title）
  recommend(data, errorback) {
    return request._post('/shop/issueorder.top/recommend', data, errorback);
  },
}

export default IssueOrderApi;




// WEBPACK FOOTER //
// ./src/api/issueorder.js